/** Lege voorwaarde: een regel die altijd geldt. */
export const ALTIJD = { soort: 'en', kinderen: [] };
// ── Wat de editor als bouwstenen aanbiedt ───────────────────────────────────
/**
 * De velden van het onderdeel die in een regel gebruikt mogen worden.
 *
 * Deze lijst is de bron voor de blokkenbibliotheek in scherm 06 én voor de
 * veldopzoeking in de motor: staat een pad hier niet in, dan bestaat het niet.
 */
export const VELDEN = [
    { pad: 'onderdeel.aantal', label: 'Aantal', eenheid: 'stuk' },
    { pad: 'onderdeel.lengte', label: 'Netto lengte', eenheid: 'mm' },
    { pad: 'onderdeel.breedte', label: 'Netto breedte', eenheid: 'mm' },
    { pad: 'onderdeel.dikte', label: 'Netto dikte', eenheid: 'mm' },
    { pad: 'onderdeel.materiaal', label: 'Materiaal', eenheid: '' },
    { pad: 'onderdeel.zijden.zijde0', label: 'Afwerking zijde 0', eenheid: '' },
    { pad: 'onderdeel.zijden.zijde5', label: 'Afwerking zijde 5', eenheid: '' },
    { pad: 'onderdeel.zijden.zijde1', label: 'Kant 1_1', eenheid: '' },
    { pad: 'onderdeel.zijden.zijde2', label: 'Kant 1_2', eenheid: '' },
    { pad: 'onderdeel.zijden.zijde3', label: 'Kant 2_3', eenheid: '' },
    { pad: 'onderdeel.zijden.zijde4', label: 'Kant 2_4', eenheid: '' },
    { pad: 'onderdeel.dekkend', label: 'Dekkend', eenheid: '' },
    { pad: 'onderdeel.overmaatLengte', label: 'Handmatige overmaat lengte', eenheid: 'mm' },
    { pad: 'onderdeel.overmaatBreedte', label: 'Handmatige overmaat breedte', eenheid: 'mm' },
    { pad: 'onderdeel.overmaatKarweiLengte', label: 'Overmaat karwei lengte', eenheid: 'mm' },
    { pad: 'onderdeel.overmaatKarweiBreedte', label: 'Overmaat karwei breedte', eenheid: 'mm' },
];
/** De opzoekwaarden uit de coderingen die in een regel gebruikt mogen worden. */
export const TABELWAARDEN = [
    { pad: 'Fineer.Aanwezig', label: 'Fineer op zijde 0 of 5', eenheid: '' },
    { pad: 'Fineer.Dikte.Zijde0', label: 'Fineerdikte zijde 0', eenheid: 'mm' },
    { pad: 'Fineer.Dikte.Zijde5', label: 'Fineerdikte zijde 5', eenheid: 'mm' },
    { pad: 'Fineer.Dikte.Totaal', label: 'Fineerdikte totaal', eenheid: 'mm' },
    { pad: 'Fineer.Code.Zijde0', label: 'Fineercode zijde 0', eenheid: '' },
    { pad: 'Fineer.Code.Zijde5', label: 'Fineercode zijde 5', eenheid: '' },
    { pad: 'Kant.Toeslag.Lengte', label: 'Kantenbandtoeslag op de lengte', eenheid: 'mm' },
    { pad: 'Kant.Toeslag.Breedte', label: 'Kantenbandtoeslag op de breedte', eenheid: 'mm' },
    { pad: 'Materiaal.Massief', label: 'Is massief hout', eenheid: '' },
    { pad: 'Materiaal.VasteDikte', label: 'Heeft een vaste dikte', eenheid: '' },
];
/** De parameters die de applicatie zelf uit de regels leest. */
export const KERNPARAMETERS = [
    { naam: 'overmaatLengte', uitleg: 'Overmaat op de lengte bij het zagen.', eenheid: 'mm' },
    { naam: 'overmaatBreedte', uitleg: 'Overmaat op de breedte bij het zagen.', eenheid: 'mm' },
    { naam: 'zaagLengte', uitleg: 'De lengte waarop gezaagd wordt.', eenheid: 'mm' },
    { naam: 'zaagBreedte', uitleg: 'De breedte waarop gezaagd wordt.', eenheid: 'mm' },
    { naam: 'calibreerdikte', uitleg: 'De kerndikte waarop gecalibreerd wordt.', eenheid: 'mm' },
];
//# sourceMappingURL=regels.js.map